
import { TableContainer, } from "components/Dashboard/Loan/style"
import React, { useMemo } from "react"
import { useAdminData } from "services/AdminUserService"
import { STAFFCOLUMNS } from "./columns"
import { observer } from "mobx-react-lite"
import { Table } from "antd"
// import { RemoveSelectedStaffButton } from "./RemoveStaffButton"
import ShowStaffDetailsButton from "./ShowStaffDetailsButton"

const AdminTable = ({ onAddStaff }) => {
	// const [selectedAdmins,setSelectedAdmins] = useState([])
	const onSuccess = () => { }
	const onError = () => {}

	const { isLoading, data: adminData,refetch } = useAdminData(onSuccess, onError)

	const columns = [
		// {
		// 	render(_,rowData){
		// 		return <Checkbox
		// 		checked={selectedAdmins.includes(rowData.id)}
		// 		onClick={()=>{
		// 			setSelectedAdmins(prev=>{
		// 				if(prev.includes(rowData.id)){
		// 					return prev.filter(item =>item !== rowData.id)
		// 				}
		// 				return [...prev,rowData.id]
		// 			})
		// 		}}
		// 		/>
		// 	}
		// },
		...STAFFCOLUMNS,
		{
			title: "Details",
			render: (_, originalRow) => (
				<ShowStaffDetailsButton adminDetails={originalRow} refetch={refetch}/>
			)
		}
	]
	const data = useMemo(() => {
		const allAdmin = adminData?.data?.data ? adminData?.data?.data : []
		return allAdmin
	}, [adminData?.data?.data])

	return (
		<>
			<TableContainer>
				<header className="flex items-center mb-4 gap-x-4">
					{/* <FilterComp filter={globalFilter} setFilter={setGlobalFilter} /> */}
					<button className="px-6 py-2 ml-auto text-sm text-white rounded-lg bg-primary" onClick={onAddStaff}>Add staff</button>
					{/* <RemoveSelectedStaffButton selectedAdmins={selectedAdmins}/> */}
				</header>
				<div>
					<Table loading={isLoading} 
					scroll={{x:"max-content"}}
					dataSource={data} columns={columns}/>
				</div>
			</TableContainer>
		</>
	)
}

export default observer(AdminTable)
